import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route, NavigationExtras, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { StarbaseLoginService } from 'starbase-login';
import { CRAWLER_AGENTS, robots } from './crawlers';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private _loginSvc: StarbaseLoginService, private _router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this._loginSvc.isLoggedIn()) {
      return true;
    }
    // otherwise we re-route to the login view
    console.warn('User not authenticated. Re-routing...');
    this._router.navigate(['login/out']);
    return false;
  }
}

@Injectable({
  providedIn: 'root'
})
export class ImageAuthGuardService implements CanActivate {

  constructor(private _loginSvc: StarbaseLoginService, private _router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this._loginSvc.isLoggedIn()) {
      return true;
    }
    const imageUID = +next.paramMap.get('id');

    // otherwise we re-route to the login view
    console.warn('User not authenticated. Re-routing...');
    if (imageUID) {
      this._router.navigate(['login/image/' + imageUID]);
      return false;
    } else {
    this._router.navigate(['login/out']);
    return false;
    }
  }
}

@Injectable({
  providedIn: 'root'
})
export class LibAuthGuardService implements CanActivate {

  constructor(private _loginSvc: StarbaseLoginService, private _router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const user = this._loginSvc.getUserModel();

    return user.isAdmin() || user.isInUserGroup('Librarian');
  }
}


@Injectable({
  providedIn: 'root'
})
export class LoggedInService implements CanActivate {

  constructor(private _loginSvc: StarbaseLoginService, private _router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (!this._loginSvc.isLoggedIn()) {
      //User not logged in
      return true;
    }
    //User already logged in, redirecting to gateway
    // eslint-disable-next-line max-len
    const queryParams: NavigationExtras = (state.root.queryParams?.contactus ? { queryParams: { contactus: state.root.queryParams.contactus }} : null);
    if (queryParams) {
      this._router.navigate(['gateway'], queryParams);
      return false;
    }
    this._router.navigate(['gateway']);
    return false;
  }
}

@Injectable({
  providedIn: 'root'
})
export class GoogleBotAuthGuardService implements CanActivate {

  constructor(private _loginSvc: StarbaseLoginService, private _router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this._loginSvc.isLoggedIn()) {
      return true;
    } else if (robots.test(window.navigator.userAgent)) {
      return true;
    }
    // otherwise we re-route to the login view
    console.warn('User not authenticated. Re-routing...');
    this._router.navigate(['login/out']);
    return false;
  }
}

@Injectable({
  providedIn: 'root'
})
export class ImageGoogleBotAuthGuardService implements CanActivate {

  constructor(private _loginSvc: StarbaseLoginService, private _router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this._loginSvc.isLoggedIn()) {
      return true;
    } else if (robots.test(window.navigator.userAgent)) {
      return true;
    }
    const imageUID = +next.paramMap.get('id');

    // otherwise we re-route to the login view
    console.warn('User not authenticated. Re-routing...');
    if (imageUID) {
      this._router.navigate(['login/image/' + imageUID]);
      return false;
    } else {
    this._router.navigate(['login/out']);
    return false;
    }
  }
}
